import React from 'react';
import { MobileStockLocationSessionStatus } from '../../../../../types/mobile_stock_location';

interface MobileStockLocationSessionStatusLabelProps {
  status: MobileStockLocationSessionStatus;
}

export function MobileStockLocationSessionStatusLabel({ status }: MobileStockLocationSessionStatusLabelProps) {
  const colors = {
    [MobileStockLocationSessionStatus.active]: 'bg-success-100 text-success-800',
    [MobileStockLocationSessionStatus.completed]: 'bg-gray-100 text-gray-800',
  };

  return <span className={`w-fit rounded-2 px-2 py-1 text-sm ${colors[status]}`}>{status}</span>;
}
